/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError,
  VersionRevertInput,
  Versions,
  VersionsParams
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Versions list
 */
export const versions = (
    params: MaybeRefOrGetter<VersionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Versions>(
      {url: `/versions`, method: 'GET',
        params, signal
    },
      );
    }




export const getVersionsQueryKey = (params?: MaybeRefOrGetter<VersionsParams>,) => {
    return [
    'versions', ...(params ? [params] : [])
    ] as const;
    }


export const getVersionsQueryOptions = <TData = Awaited<ReturnType<typeof versions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params: MaybeRefOrGetter<VersionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof versions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof versions>>> = ({ signal }) => versions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof versions>>, TError, TData>
}

export type VersionsQueryResult = NonNullable<Awaited<ReturnType<typeof versions>>>
export type VersionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Versions list
 */

export function useVersions<TData = Awaited<ReturnType<typeof versions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params: MaybeRefOrGetter<VersionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof versions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Revert one field of a version
 */
export const revertVersion = (
    id: MaybeRefOrGetter<string>,
    versionRevertInput: MaybeRefOrGetter<VersionRevertInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
versionRevertInput = toValue(versionRevertInput);

      return axiosClient<void>(
      {url: `/versions/${id}/revert`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: versionRevertInput, signal
    },
      );
    }




export const getRevertVersionMutationKey = () => ['revertVersion'] as const;

export const getRevertVersionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertVersion>>, TError,RevertVersionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revertVersion>>, TError,RevertVersionMutationVariables, TContext> => {

const mutationKey = getRevertVersionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revertVersion>>, RevertVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  revertVersion(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevertVersionMutationResult = NonNullable<Awaited<ReturnType<typeof revertVersion>>>
    export type RevertVersionMutationBody = VersionRevertInput
    export type RevertVersionMutationError = ErrorType<ValidationError | StandardError>
    export type RevertVersionMutationVariables = {id: string;data: VersionRevertInput}

    /**
 * @summary Revert one field of a version
 */
export const useRevertVersion = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revertVersion>>, TError,RevertVersionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof revertVersion>>,
        TError,
        RevertVersionMutationVariables,
        TContext
      > => {
      return useMutation(getRevertVersionMutationOptions(options), queryClient);
    }
